const initializeHomeProductCard = () => {
  // SP幅の判定（必要に応じて値を調整）
  const mq = window.matchMedia('(max-width: 767px)');

  const cards = Array.from(document.querySelectorAll('.m-home-product-card'));
  if (cards.length === 0) return;

  // 外側クリックで全カードを閉じるためのハンドラ
  let onDocumentClick = null;
  // 直近に操作したカード
  let activeCard = null;

  const attach = () => {
    cards.forEach((card) => {
      if (card.__hpBound) return;

      card.__hpClickHandler = (e) => {
        const isInteractive =
          e.target.closest('a, button, input, select, textarea') !== null;
        if (isInteractive) return;

        card.classList.toggle('is-open');
        if (card.classList.contains('is-open')) {
          activeCard = card;
        } else if (activeCard === card) {
          activeCard = null;
        }
      };

      const overlay = card.querySelector('.m-home-product-card__overlay');
      if (overlay) {
        overlay.__hpCloseHandler = (e) => {
          const isInteractive =
            e.target.closest('a, button, input, select, textarea') !== null;
          if (isInteractive) return;
          card.classList.remove('is-open');
        };
      }

      card.addEventListener('click', card.__hpClickHandler, { passive: true });
      overlay?.addEventListener('click', overlay.__hpCloseHandler, {
        passive: true,
      });

      card.__hpBound = true;
    });

    // カード外側クリックで全カードを閉じる
    if (!onDocumentClick) {
      onDocumentClick = (e) => {
        if (!activeCard) return;
        const clickedCard = e.target.closest('.m-home-product-card');
        // アクティブカード内のクリックは無視
        if (clickedCard === activeCard) return;
        // アクティブカードの外側クリックでそのカードのみ閉じる
        activeCard.classList.remove('is-open');
        activeCard = null;
      };
      // キャプチャ段階で先に評価し、別カードクリック時に先に前カードを閉じる
      document.addEventListener('click', onDocumentClick, {
        passive: true,
        capture: true,
      });
    }
  };

  const detach = () => {
    cards.forEach((card) => {
      if (!card.__hpBound) return;
      card.removeEventListener('click', card.__hpClickHandler);
      const overlay = card.querySelector('.m-home-product-card__overlay');
      overlay?.removeEventListener('click', overlay.__hpCloseHandler);
      card.__hpBound = false;
      card.classList.remove('is-open');
    });

    if (onDocumentClick) {
      document.removeEventListener('click', onDocumentClick, { capture: true });
      onDocumentClick = null;
    }

    activeCard = null;
  };

  const apply = () => {
    if (mq.matches) {
      attach();
    } else {
      detach();
    }
  };

  apply();
  mq.addEventListener('change', apply);
};

export { initializeHomeProductCard };
